export const environment = {
  useO365: false,
  cognito: {
    authority: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_5wTuumMRE',
    clientId: '46r6i0nahd3ainr7ffg43n6rec'
  },
  websocket: {
    url: 'wss://ifqon6r5eg.execute-api.eu-west-1.amazonaws.com/dev'
  },
  hubspot: {
    baseUrl: 'https://app-eu1.hubspot.com',
    portalId: '143207988'
  },
  helos20: {
    // Staging
    baseUrl: 'https://d1qh78hqo1rlev.cloudfront.net'
  },
  netvisor: {
    baseUrl: 'https://koulutus.netvisor.fi/evo/accounting'
  }
};
